<template>
  <div class="Assignment">
    <p class="line">
        <b></b>债务方情况
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <span>还款能力：</span>
            <el-radio v-model="radio1" label="有能力">有能力</el-radio>
            <el-radio v-model="radio1" label="无能力">无能力</el-radio>
        </li>
        <li>
            <span>担保能力：</span>
            <el-radio v-model="radio2" label="有能力">有能力</el-radio>
            <el-radio v-model="radio2" label="无能力">无能力</el-radio>
        </li>
    </ul>
    <p class="line" style="padding-top:3%">
        <b></b>担保方情况
    </p>
    <ul>
        <li style="margin-right: 20%;" class="select">
            <span>担保方式：</span>
            <el-select v-model="value1" placeholder="请选择">
                <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </li>
        <li class="select">
            <span>经济情况：</span>
            <el-select v-model="value2" placeholder="请选择">
                <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </li>
        <li style="margin-right: 20%;">
            <span>是否联系：</span>
            <el-radio v-model="radio3" label="是">是</el-radio>
            <el-radio v-model="radio3" label="否">否</el-radio>
        </li>
        <li>
            <span>抵/质押物价格：</span>
            <el-radio v-model="radio4" label="已超债务">已超债务</el-radio>
            <el-radio v-model="radio4" label="未超债务">未超债务</el-radio>
        </li>
    </ul>
    <p class="line" style="padding-top:3%">
        <b></b>诉讼与判决
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <span>诉讼与否：</span>
            <el-radio v-model="radio5" label="已诉讼">已诉讼</el-radio>
            <el-radio v-model="radio5" label="未诉讼">未诉讼</el-radio>
        </li>
        <li>
            <span>判决与否：</span>
            <el-radio v-model="radio6" label="已判决">已判决</el-radio>
            <el-radio v-model="radio6" label="未判决">未判决</el-radio>
        </li><li>
            <span>执行与否：</span>
            <el-radio v-model="radio7" label="已执行">已执行</el-radio>
            <el-radio v-model="radio7" label="未执行">未执行</el-radio>
        </li>
    </ul>
    <div class="check">
        <button @click="back()">上一步</button>
        <button class="active" @click="nextone()">下一步</button>
    </div>

  </div>
</template>

<script>
export default {
  props:{

  },
  data () {
    return {
        radio1:'无能力',
        radio2:'无能力',
        options1: [{value: '质押担保',label: '质押担保'}, {value: '保证担保',label: '保证担保'}, {value: '信用担保',label: '信用担保'}, {value: '抵押担保',label: '抵押担保'}],
        value1: '',
        options2: [{value: '优',label: '优'}, {value: '良',label: '良'}, {value: '差',label: '差'}, {value: '未知',label: '未知'}],
        value2: '',
        radio3:'否',
        radio4:'未超债务',
        radio5:'未诉讼',
        radio6:'未判决',
        radio7:'未执行',
    }
  },
  components:{

  },
  mounted(){
      if(window.sessionStorage.getItem('Assignment2')){
        var info = JSON.parse(window.sessionStorage.getItem('Assignment2'));
        this.radio1 = info.radio;
        this.radio2 = info.radio2;
        this.value1 = info.value1;
        this.value2 = info.value2;
        this.radio3 = info.radio3;
        this.radio4 = info.radio4;
        this.radio5 = info.radio5;
        this.radio6 = info.radio6;
        this.radio7 = info.radio7;
      }

  },
  methods: {
    nextone(){
        if(this.value1 == ''){
            this.$message.error('请填写担保方担保方式');
            return
        }else if(this.value2 == ''){
            this.$message.error('请填写担保方经济情况');
            return
        }
        // 数据缓存本地
        var obj = new Object();
        obj.radio1 = this.radio;
        obj.radio2 = this.radio2;
        obj.value1 = this.value1;
        obj.value2 = this.value2;
        obj.radio3 = this.radio3;
        obj.radio4 = this.radio4;
        obj.radio5 = this.radio5;
        obj.radio6 = this.radio6;
        obj.radio7 = this.radio7;
        var a = JSON.stringify(obj);
        window.sessionStorage.setItem('Assignment2',a); 
        
        // ***跳转
        // this.$emit('son','3')
        // return;
        // --------------------------

        var _this = this;
        let param = new URLSearchParams();
        param.append("flag", '2');
        param.append("re_repaymentability", this.radio1);
        param.append("re_ensure", this.radio2);
        param.append("re_ensureway", this.value1);
        param.append("re_ensurepersonincome", this.value2);
        param.append("re_ensureperson", this.radio3);
        param.append("re_pawnability", this.radio4);
        param.append("re_lawsuitinfo", this.radio5);
        param.append("re_judgmentinfo", this.radio6);
        param.append("re_execute", this.radio7);
        param.append("orderid",window.sessionStorage.getItem('orderid'));
        this.$http.post(api.Assignment,param).then(function(res){
            if(res.data.code == 100001){
                // console.log(res);
                window.sessionStorage.setItem('orderid',res.data.data.orderid);
                _this.$emit('son','3')
            }else{
                _this.$message.error(res.data.message);
            }
        })
    },
    back(){
        this.$emit('son','1')
    }   
  }
}



</script>

<style scoped >

.Assignment{
    background:#FFFFFF;
    padding: 3% 3%;
}
.Assignment .line{
    color: #2fb8c2;
    font-weight: bold;
}
.Assignment .line b{
    display: inline-block;
    width: 5px;
    background: #2fb8c2;
    height: 20px;
    vertical-align: bottom;
    margin-right: 1rem;
    border-radius: 10px;
}
.Assignment ul{
    overflow:hidden;
}
.Assignment ul li{
    float:left;
    box-sizing: border-box;
    width:40%;
    margin-top: 10px;
    padding: 30px 0;
    border-bottom: 1px solid #d3d3d3;
    height: 100px;
    
}
.Assignment ul li span{
    display: inline-block;
    width: 21%;
    text-align:left;
}
.Assignment ul li>label{
    text-align:center;
    width:35%
    
}
.select{
    text-align: right;
}
.select span{
    float:left;
    line-height:40px;
}
.check{
    padding-top: 3%;
    text-align:center;
}
.check button{
    border: none;
    outline: none;
    padding: 20px 50px;
    border-radius: 10px;
    background: #FFFFFF;
    border: 1px solid #d3d3d3;
    margin: 0 50px;
    cursor: pointer;
}
.check button:hover{
    background:#2fb8c2;
    color:#ffffff;
}
.check button.active{
    background:#2fb8c2;
    color:#ffffff;
}
.input{
    width:75%
}

</style>



// WEBPACK FOOTER //
// src/common/Assignment2.vue